import { handleActions } from 'redux-actions';
import {
  SET_REINITIALIZING,
  SetReinitializingAction,
} from '../actions/reinitializing';

export type ReinitializingState = boolean;

export default handleActions<ReinitializingState, any>(
  {
    [SET_REINITIALIZING]: (
      _state: ReinitializingState,
      { payload }: SetReinitializingAction,
    ) => Boolean(payload),
  },
  false,
);
